import { useEffect, useState } from 'react'

import { useFocusNodeById } from '@please/lrud'
import type { Swiper as SwiperType } from 'swiper'

import { UpdatedSliderData } from '@/components/Lines/hooks'

export const useVisiableSliderNavigation = ({
  nodeId,
  swiper,
  sliderData,
  slidesPerView,
}: {
  nodeId: string
  swiper: Nullable<SwiperType>
  sliderData: UpdatedSliderData[]
  slidesPerView: number
}) => {
  const focusNode = useFocusNodeById(nodeId)
  const [isNextArrowVisible, setIsNextArrowVisible] = useState(false)
  const [isPrevArrowVisible, setIsPrevArrowVisible] = useState(false)
  const isNavigationVisible =
    (sliderData?.length || 0) > slidesPerView && !!focusNode?.isFocused

  useEffect(() => {
    swiper && sliderData?.length && updateArrowVisiable()
  }, [swiper, sliderData?.length, focusNode?.isFocused])

  const updateArrowVisiable = () => {
    if (!swiper) {
      return
    }

    const transform = swiper.wrapperEl.style.transform
    const trimValue = transform.slice(
      transform.indexOf('(') + 1,
      transform.lastIndexOf(')'),
    )
    const currentTransform = parseInt(trimValue.split(',')[0])
    const virtualSize = Math.floor(
      (swiper as any).virtualSize -
        swiper.width -
        (swiper.params?.slidesOffsetBefore || 0),
    )
    const diff = virtualSize + currentTransform

    const isNextArrowVisible = diff > 0
    const isPrevArrowVisible = diff < virtualSize

    setIsNextArrowVisible(isNavigationVisible && isNextArrowVisible)
    setIsPrevArrowVisible(isNavigationVisible && isPrevArrowVisible)
  }

  return { isNextArrowVisible, isPrevArrowVisible, updateArrowVisiable }
}
